import { notification } from 'antd';
import { all, call, put, take } from 'redux-saga/effects';
import update from 'immutability-helper';
import * as moment from 'moment';
// import { notifyMessageAction } from 'store/notification/action';
// import { history } from 'store';
import {
  LOAD_TIME_SLOT_LIST,
  HOLD_BOOKING_SLOT,
  RELEASE_BOOKING_SLOT,
  BOOK_APPOINTMENT,
  SAVE_SELECTED_BOOKING_SLOT,
  CLEAR_SELECTED_BOOKING_SLOT,
  LOAD_BOOKING_DETAIL,
  RESCHEDULE_BOOKING,
  CANCEL_BOOKING,
  UPDATE_BOOKING_INFO,
} from '../type';
import {
  loadTimeSlotListSuccessAction,
  loadTimeSlotListErrorAction,
  holdBookingSlotSuccessAction,
  holdBookingSlotErrorAction,
  releaseBookingSlotAction,
  releaseBookingSlotSuccessAction,
  releaseBookingSlotErrorAction,
  bookAppointmentSuccessAction,
  bookAppointmentErrorAction,
  saveSelectedBookingSlotSuccessAction,
  saveSelectedBookingSlotErrorAction,
  clearSelectedBookingSlotAction,
  clearSelectedBookingSlotSuccessAction,
  clearSelectedBookingSlotErrorAction,
  loadBookingDetailSuccessAction,
  loadBookingDetailErrorAction,
  loadBookingDetailAction,
  rescheduleBookingSuccessAction,
  rescheduleBookingErrorAction,
  cancelBookingSuccessAction,
  cancelBookingErrorAction,
  updateBookingInfoSuccessAction,
  updateBookingInfoErrorAction,
} from '../action';

import { clearSelectedBookingSlotAction as clearSelectedBookingSlotFittestAction } from '../../fittest_booking/action';

import { loadPatientDetailAction } from 'store/patient/action';
import { loadProjectIdentificationDetailAction } from 'store/project_identification/action';

import { history } from 'store';

import { convertUnixToDateWithTimezone } from 'utils';
import { bookingService, patientService } from 'services';
import { AUS_TIME_ZONE, Format } from 'common/enum';

function* loadTimeSlotList() {
  while (1) {
    const action = yield take(LOAD_TIME_SLOT_LIST);
    const currentTimeZone = action.payload.timeZone;
    const currentTimeZoneArea = AUS_TIME_ZONE[currentTimeZone].area;
    try {
      const timeSlotList = yield call(
        bookingService.loadBookingSlotList,
        action.payload,
      );

      for (let date in timeSlotList) {
        for (let rosterUuid in timeSlotList[date]) {
          timeSlotList[date][rosterUuid].forEach(timeSlot => {
            const timeSlotTimeWithTimeZone = convertUnixToDateWithTimezone(
              timeSlot.startTime,
              currentTimeZoneArea,
            );
            timeSlot.formattedDate = timeSlotTimeWithTimeZone;
          });
        }
      }

      yield put(loadTimeSlotListSuccessAction(timeSlotList));
    } catch (err) {
      yield put(loadTimeSlotListErrorAction(err));
      notification.error({
        message: err.message,
      });
    }
  }
}

function* holdBookingSlot() {
  while (1) {
    const action = yield take(HOLD_BOOKING_SLOT);
    try {
      const holdBookingSlotResponse = yield call(
        bookingService.holdBookingSlot,
        action.payload,
      );
      if (holdBookingSlotResponse && holdBookingSlotResponse.success) {
        yield put(holdBookingSlotSuccessAction(holdBookingSlotResponse));
      } else {
        if (action.payload.callback) {
          action.payload.callback();
        }
        throw new Error(holdBookingSlotResponse.message);
      }
    } catch (err) {
      notification.error({
        message: err.message,
      });
      yield put(holdBookingSlotErrorAction(err));
    }
  }
}

function* releaseBookingSlot() {
  while (1) {
    const action = yield take(RELEASE_BOOKING_SLOT);
    try {
      const holdBookingSlotResponse = yield call(
        bookingService.releaseBookingSlot,
        action.payload,
      );
      yield put(releaseBookingSlotSuccessAction(holdBookingSlotResponse));
    } catch (err) {
      notification.error({
        message: err.message,
      });
      yield put(releaseBookingSlotErrorAction(err));
    }
  }
}

function* bookAppointment() {
  while (1) {
    const action = yield take(BOOK_APPOINTMENT);
    const values = action.payload;

    let {
      generalCandidateId: patientId,
      selectedBookingSlot,
      organisationId,
      fitTestCurrentHoldingSlot,
      currentHoldingSlot,
    } = values;

    const callBack = action.payload.callback;
    try {
      let pemCaseId = null;
      let pemCaseName = '';
      let fitTestCaseId = null;
      let fitTestCaseName = '';
      const dateInjury = moment(new Date()).toISOString();

      if (values.fittest && values.fittest.package) {
        fitTestCaseName = 'PEM - Fit Test';
        const fitTestCaseInfo = yield call(patientService.createPatientCase, {
          patientId,
          organisationId,
          caseProblemName: fitTestCaseName,
          dateInjury: dateInjury,
        });
        fitTestCaseId = fitTestCaseInfo.id;
      }
      if (values.package) {
        pemCaseName = `PreEmployment - PEM${
          selectedBookingSlot && selectedBookingSlot.startTime
            ? ` - ${convertUnixToDateWithTimezone(
                selectedBookingSlot && selectedBookingSlot.startTime,
                AUS_TIME_ZONE.UTC800.area,
                Format.Date,
              )}`
            : ''
        }`;
        const pemCaseInfo = yield call(patientService.createPatientCase, {
          patientId,
          organisationId,
          caseProblemName: pemCaseName,
          dateInjury: dateInjury,
        });

        pemCaseId = pemCaseInfo.id;
      }

      const pemAdditionalData = {
        caseId: { $set: pemCaseId },
        caseName: { $set: pemCaseName },
      };

      const fitTestAdditionalData = {
        caseId: { $set: fitTestCaseId },
        caseName: { $set: fitTestCaseName },
      };

      let updatedValues = null;

      if (values.packageRequest.length === 2) {
        // The booking has 2 packages
        updatedValues = update(values, {
          packageRequest: {
            0: pemAdditionalData,
            1: fitTestAdditionalData,
          },
        });
      } else if (values.packageRequest.length === 1) {
        if (values.fittest && values.fittest.package) {
          // The booking has only 1 Fit Test package
          updatedValues = update(values, {
            packageRequest: {
              0: fitTestAdditionalData,
            },
          });
        } else if (values.package) {
          // The booking has only 1 PEM package
          updatedValues = update(values, {
            packageRequest: {
              0: pemAdditionalData,
            },
          });
        }
      }

      const bookedAppointment = yield call(
        bookingService.bookAppointment,
        updatedValues,
      );

      const appointmentId = bookedAppointment.appointmentId;
      organisationId = bookedAppointment.organisationId;

      if (callBack) {
        callBack();
      }
      if (fitTestCurrentHoldingSlot) {
        yield put(
          releaseBookingSlotAction({
            uuid: fitTestCurrentHoldingSlot.uuid,
          }),
        );
      }

      if (currentHoldingSlot) {
        yield put(
          releaseBookingSlotAction({
            uuid: currentHoldingSlot.uuid,
          }),
        );
      }
      yield put(bookAppointmentSuccessAction(bookedAppointment));
      yield put(clearSelectedBookingSlotAction());
      notification.success({
        message: 'New appointment has been successfully booked',
      });

      history.push(
        `/manage-booking/${appointmentId}/organisation/${organisationId}`,
      );
    } catch (err) {
      notification.error({
        message: err.message,
      });
      yield put(bookAppointmentErrorAction(err));
    }
  }
}

function* saveSelectedBookingSlot() {
  while (1) {
    const action = yield take(SAVE_SELECTED_BOOKING_SLOT);
    try {
      yield put(saveSelectedBookingSlotSuccessAction(action.payload));
    } catch (err) {
      yield put(saveSelectedBookingSlotErrorAction(err));
    }
  }
}

function* clearSelectedBookingSlot() {
  while (1) {
    const action = yield take(CLEAR_SELECTED_BOOKING_SLOT);
    try {
      yield put(clearSelectedBookingSlotSuccessAction(action.payload));
    } catch (err) {
      yield put(clearSelectedBookingSlotErrorAction(err));
    }
  }
}

function* loadBookingDetail() {
  while (1) {
    const action = yield take(LOAD_BOOKING_DETAIL);

    try {
      const bookedAppointment = yield call(
        bookingService.loadBookingDetail,
        action.payload,
      );
      yield put(loadBookingDetailSuccessAction(bookedAppointment));
      const organisationId = bookedAppointment.organisationId;

      const generalCandidateId = bookedAppointment.generalCandidateId;
      yield put(
        loadPatientDetailAction({
          patientId: generalCandidateId,
          organisationId: organisationId,
        }),
      );

      const projectIdentificationData =
        bookedAppointment.projectIdentificationDetail;
      const projectIdentificationDetail = projectIdentificationData
        ? JSON.parse(projectIdentificationData)
        : projectIdentificationData;

      const projectIdentificationId = projectIdentificationDetail
        ? projectIdentificationDetail.projectIdentification
        : projectIdentificationDetail;

      if (projectIdentificationId) {
        yield put(
          loadProjectIdentificationDetailAction({
            projectIdentificationId,
            organisationId: parseInt(action.payload.organisationId),
          }),
        );
      }
    } catch (err) {
      notification.error({
        message: err.message,
      });
      yield put(loadBookingDetailErrorAction(err));
      history.push('/manage-booking');
    }
  }
}

function* rescheduleBooking() {
  while (1) {
    const action = yield take(RESCHEDULE_BOOKING);
    try {
      const rescheduledBooking = yield call(
        bookingService.rescheduleBooking,
        action.payload,
      );
      const appointmentId = rescheduledBooking.appointmentId;
      const organisationId = action.payload.organisationId;
      yield put(loadBookingDetailAction({ appointmentId, organisationId }));
      yield put(rescheduleBookingSuccessAction(rescheduledBooking));
      yield put(clearSelectedBookingSlotAction());
      yield put(clearSelectedBookingSlotFittestAction());
      const callBack = action.payload.callback;

      if (callBack) {
        callBack();
      }
      notification.success({
        message: 'This appointment has been successfully rescheduled',
      });
    } catch (err) {
      notification.error({
        message: err.message,
      });
      yield put(rescheduleBookingErrorAction(err));
    }
  }
}

function* cancelBooking() {
  while (1) {
    const action = yield take(CANCEL_BOOKING);
    try {
      const cancelledBooking = yield call(
        bookingService.cancelBooking,
        action.payload,
      );

      yield put(cancelBookingSuccessAction(cancelledBooking));

      const callBack = action.payload.callback;

      if (callBack) {
        callBack();
      }
      notification.success({
        message: 'This appointment has been successfully cancelled',
      });
    } catch (err) {
      notification.error({
        message: err.message,
      });
      yield put(cancelBookingErrorAction(err));
    }
  }
}

function* updateBookingInfo() {
  while (1) {
    const action = yield take(UPDATE_BOOKING_INFO);
    try {
      const updatedBookingInfo = yield call(
        bookingService.updateBookingInfo,
        action.payload,
      );

      yield put(updateBookingInfoSuccessAction(updatedBookingInfo));
      const callBack = action.payload.callback;

      if (callBack) {
        callBack();
      }
      notification.success({
        message: 'This appointment has been successfully updated',
      });
    } catch (err) {
      notification.error({
        message: err.message,
      });
      yield put(updateBookingInfoErrorAction(err));
    }
  }
}

export default function* rootSaga() {
  yield all([
    bookAppointment(),
    releaseBookingSlot(),
    holdBookingSlot(),
    loadTimeSlotList(),
    saveSelectedBookingSlot(),
    loadBookingDetail(),
    rescheduleBooking(),
    cancelBooking(),
    updateBookingInfo(),
    clearSelectedBookingSlot(),
  ]);
}
